import React from 'react'
import { Row, Col, Button, Form, Modal, Layout, Input } from 'antd';

const { Content } = Layout;

export default function ModalForm(props) {
  const { selectedRow } = props;

  if (selectedRow === null) {
    return "";
  }

  return (
    <Modal
      title="View Details"
      visible={props.showFormModal}
      onCancel={props.handleCloseModal}
      centered={true}
      footer={null}
      width={800}
    >
      <Layout>
        <Content className='contact-form-container'>


          <Row type="flex" justify="center" gutter={30}>
            <Form onSubmit={props.handleSubmit} className="login-form">
              <Col span={8} align="center" style={{ height: 200 }}>
                <div style={{ position: "relative", height: '200px' }}>
                  {
                    selectedRow.image ? (<img
                      alt={selectedRow.name}
                      src={process.env.REACT_APP_FILES_URL + selectedRow.image}
                      style={{ maxWidth: "100%", maxHeight: "100%" }}
                    />) : (<div style={{ verticalAlign: "middle", marginTop: "30%" }}>No Image Found</div>)
                  }
                </div>
              </Col>

              <Col span={16}>
                <Form.Item label="Variant Name">
                  <Input value={selectedRow.name} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={16}>
                <Form.Item label="Description">
                  <Input value={selectedRow.description} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Variant Size">
                  <Input value={selectedRow.variants && selectedRow.variants.size ? selectedRow.variants.size : ""} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Variant Flavor">
                  <Input value={selectedRow.variants && selectedRow.variants.flavor ? selectedRow.variants.flavor : ""} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Product">
                  <Input value={`${selectedRow.product.name} - ${selectedRow.product.country_made}`} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Selling Price">
                  <Input value={selectedRow.selling_price} readOnly={true} />
                </Form.Item>
              </Col>


              <Col span={8}>
                <Form.Item label="Material Code">
                  <Input value={selectedRow.material_code} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="CBM">
                  <Input value={selectedRow.cbm} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Gross Weight">
                  <Input value={selectedRow.gross_weight} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Net Weight">
                  <Input value={selectedRow.net_weight} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Unit Of Measurement">
                  <Input value={selectedRow.uom} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="M.Unit">
                  <Input value={selectedRow.m_unit} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Dimensions">
                  <Input value={selectedRow.dimension} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item label="Status">
                  <Input value={selectedRow.status ? "Active" : "Inactive"} readOnly={true} />
                </Form.Item>
              </Col>

              <Col span={24} align="right">
                <Form.Item>
                  <Button key="back" onClick={props.handleCloseModal}>
                    Close
                  </Button>
                </Form.Item>
              </Col>
            </Form>
          </Row>
        </Content>
      </Layout>
    </Modal>
  )
}
